import React from 'react';

import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableRow from '@material-ui/core/TableRow';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import {makeStyles} from '@material-ui/core/styles';
import TableContainer from '@material-ui/core/TableContainer';
import TablePagination from '@material-ui/core/TablePagination';

import EfeCellTable from './efe-table-components/EfeCellTable';
import EfeHeaderTable from './efe-table-components/EfeHeaderTable';
import {createDatasource, StyledTableRow} from './efe-table-components/table-helpers';
import {Column, TableAction, TableItem} from 'commons/models/components/EfeTableValues';
import {Box, Grid, Typography} from '@material-ui/core';

const useStyles = makeStyles({
    root: {
        width: '100%',
    },
    container: {
        maxHeight: 440,
    },
});

type Props = {
    title: string;
    page: number;
    rowsPerPage: number;
    handleChangePage: (page: number) => void;
    handleAction?: (action: TableAction) => void;
    handleChangeRowsPerPage: (rowsPerPage: number) => void;
    data: Array<any>;
    totalElements: number;
    columns: Array<Column>;
};

function EfeTable(props: Props) {
    const classes = useStyles();

    const [items, setItems] = React.useState<Array<TableItem>>([]);

    const {
        title,
        data,
        columns,
        totalElements,
        handleChangePage,
        handleChangeRowsPerPage,
        page,
        rowsPerPage,
        handleAction,
    } = props;

    React.useEffect(() => {
        setItems(Object.assign(createDatasource(columns, data)));
    }, [data]);

    return (
        <Paper className={classes.root}>
            <Box display='flex' flexDirection='row' justifyContent='center' mt={2}>
                <Grid container spacing={2} justifyContent={'center'}>
                    <Typography variant={'h4'}>{title}</Typography>
                </Grid>
            </Box>
            <TableContainer className={classes.container}>
                <Table stickyHeader aria-label='sticky table'>
                    <TableHead>
                        <TableRow>
                            {columns &&
                                columns.map((column, index) => (
                                    <EfeHeaderTable column={column} index={index} key={index} />
                                ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {items &&
                            items.map((rowData, key) => {
                                return (
                                    <StyledTableRow key={key}>
                                        {columns &&
                                            columns.map((column: Column, index: number) => (
                                                <EfeCellTable
                                                    handleAction={handleAction}
                                                    column={column}
                                                    data={rowData.data}
                                                    index={index}
                                                    key={index}
                                                    minWidth={column.minWidth}
                                                />
                                            ))}
                                    </StyledTableRow>
                                );
                            })}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[10, 25, 100]}
                component='div'
                count={totalElements}
                rowsPerPage={rowsPerPage}
                page={page - 1}
                onPageChange={(event: unknown, newPage: number) => handleChangePage(newPage + 1)}
                onRowsPerPageChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                    handleChangeRowsPerPage(+event.target.value)
                }
            />
        </Paper>
    );
}

export default EfeTable;
